define('plugin/client-login/view/ClientLoginPasswordView',['require','lib/view/FormView','underscore'],function (require) {

    var FormView = require('lib/view/FormView');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg

    /**
     * Client password
     *
     * @class ClientLoginPasswordView
     */
    return FormView.extend({

        template: '#client_login_profile_password',
        ui: {
            'remind_btn': '#sb_update_btn',
            'inputs': ':input'
        },
        triggers: {
            'click @ui.remind_btn': 'update'
        },
        modelEvents: {
            'invalid': 'render',
           // 'sync': 'safeRender'
        },

        initialize: function () {
            FormView.prototype.initialize.apply(this);

            this.clientModel = this.getOption('clientModel');

            this.clientModel.on('change:client_hash', this.safeRender, this);

            this.model.on('sync', _.bind(function () {
                this.clientModel.fetch();

                if(this.model.get('success')) {
                    setTimeout(function() {
                        Backbone.history.navigate('client/profile', {trigger: true});
                    }, 3000);
                }
            }, this));
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        getProfileData: function () {
            return this._getData(this.ui.inputs);
        },

        serializeData: function () {
            var data = _.extend({
                'is_modal': this.getOption('isModal'),
                'client_hash': this.clientModel.get('client_hash'),
            }, this._serializeData());

            if(data.errors){
                _.each(data.errors, function(errors, field){
                    // Show only first error for each field
                    if(_.isArray(errors) && errors.length > 1){
                        data.errors[field] = errors[0];
                    }
                });
            }

            return data;
        }

    });

});
